import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
BookOpenIcon,
CheckCircleIcon,
ArrowLeftEndOnRectangleIcon,
AcademicCapIcon,
Bars3Icon,
XMarkIcon,
HomeIcon, // Adicionado ícone Home para dashboard
} from "@heroicons/react/24/outline";

const Sidebar = ({ initialOpen = true }) => {
const [isOpen, setIsOpen] = useState(initialOpen);

const navItems = [
{ name: "Dashboard", link: "/dashboard", icon: HomeIcon }, // Usando HomeIcon para Dashboard
{ name: "Meu Progresso", link: "/progresso", icon: AcademicCapIcon },
{ name: "Concluídos", link: "/concluidos", icon: CheckCircleIcon },
];

// Classes de estilo base
const baseClasses = "h-screen border-r border-slate-800 bg-slate-900/90 flex flex-col transition-all duration-300 shadow-2xl z-20";
const openWidth = "w-64";
const closedWidth = "w-20";

return (
<div
className={`${baseClasses} ${isOpen ? openWidth : closedWidth}`}
>
{/* Título / Logo e Botão de Toggle */}
<div
className={`p-4 flex items-center h-16 border-b border-slate-800 transition-all ${
isOpen ? "justify-between" : "justify-center"
}`}
>
{isOpen && (
<span className="text-xl font-bold text-indigo-400 whitespace-nowrap overflow-hidden">
Plataforma
</span>
)}
<button
onClick={() => setIsOpen(!isOpen)}
className="text-slate-400 p-2 rounded-full hover:bg-slate-700 hover:text-indigo-400"
title={isOpen ? "Recolher Sidebar" : "Expandir Sidebar"}
>
{isOpen ? (
<XMarkIcon className="w-6 h-6" />
) : (
<Bars3Icon className="w-6 h-6" />
)}
</button>
</div>


{/* Navegação Principal */}
<nav className="flex-1 px-3 py-4 space-y-2 overflow-y-auto">
{navItems.map((item) => (
<NavLink
key={item.name}
to={item.link}
className={({ isActive }) =>
`flex items-center p-3 rounded-xl transition-colors text-sm
${
isOpen ? "justify-start" : "justify-center"
} ${
isActive
? "bg-indigo-600/30 text-indigo-400 font-semibold border border-indigo-500/50"
: "text-slate-300 hover:bg-slate-700 hover:text-white"
}`
}
>
<item.icon className="w-6 h-6 flex-shrink-0" />
<span
className={`ml-3 transition-all duration-300 overflow-hidden whitespace-nowrap ${
isOpen ? "opacity-100 w-auto" : "opacity-0 w-0"
}`}
>
{item.name}
</span>
</NavLink>
))}
</nav>


{/* Rodapé / Logout */}
<div className="p-3 border-t border-slate-800">
</div>
</div>
);
};

export default Sidebar;